<template>
  <!-- 公共布局组件 Layout.vue -->
  <div class="app-container">
    <!-- 主要内容区域 -->
    <router-view />
    <!-- 底部导航栏 -->
    <van-tabbar v-model="active" route active-color="#333333" inactive-color="#B5B5B5" safe-area-inset-bottom>
      <van-tabbar-item v-for="(item, index) in tabbarItems" :key="index" :to="item.route" :icon="item.icon">
        {{ item.title }}
        <!-- 自定义选中图标 -->
        <template #icon="props">
          <img style="width: 24px;height: 24px;" :src="props.active ? item.activeIcon : item.inactiveIcon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
    props: ['isTeam'],
  data() {
    // 这里存放数据
    return {
      active: 0,
      tabbarItems: [
        {
          title: '首页',
          route: '/',
          activeIcon: require('@/assets/tabImg/home1@2x.png'),
          inactiveIcon: require('@/assets/tabImg/home@2x.png')
        },
        {
          title: '选课',
          route: '/chooseClass',
          activeIcon: require('@/assets/tabImg/xk1@2x.png'),
          inactiveIcon: require('@/assets/tabImg/xk@2x.png')
        },
        {
          title: '学习',
          route: '/myClass',
          activeIcon: require('@/assets/tabImg/study1@2x.png'),
          inactiveIcon: require('@/assets/tabImg/study@2x.png'),
          // 添加购物车数量徽标
          dot: true,
          info: this.$store.getters.cartCount
        },
        {
          title: '我的',
          route: '/my',
          activeIcon: require('@/assets/tabImg/my1@2x.png'),
          inactiveIcon: require('@/assets/tabImg/my@2x.png')
        }
      ]
    };
  },
  watch: {
    // 监听路由变化同步导航栏状态
    '$route.path': {
      immediate: true,
      handler(newPath) {
        const index = this.tabbarItems.findIndex(item => {
          item.route === newPath || newPath.startsWith(item.route);
          if (index > -1) this.active = index;
        });
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less">
/* //@import url(); 引入公共css类 */
.app-container {
  margin-top: 50px;
}
/* 自定义导航栏样式 */
.van-tabbar {
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
  height: 50px;
}

.van-tabbar-item__icon img {
  width: 24px;
  height: 24px;
}

/* 选中状态文字加粗 */
.van-tabbar-item--active {
  font-weight: bold;
}
</style>
